export default __webpack_public_path__ + "static/media/icon_star-full.fb5d60d4.svg";